import { css } from '@emotion/css';
import { Color, FontWeight, Spacing } from 'src/styles';

export const phoneNumberSpan = css`
  ${FontWeight.bold}
  color: ${Color.Gray8}
`;

export const button = css`
  ${Spacing.m8}
`;
